const TournamentMatchesTypes = {
    GET_TOURNAMENT_MATCHES_START:'GET_TOURNAMENT_MATCHES_START',
    GET_TOURNAMENT_MATCHES_SUCCESS:'GET_TOURNAMENT_MATCHES_SUCCESS',
    GET_TOURNAMENT_MATCHES_FAILED:'GET_TOURNAMENT_MATCHES_FAILED',

}

export default TournamentMatchesTypes